import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Icon } from '@iconify/react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

function PricingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedPlans, setSelectedPlans] = useState({
    basic: { accounts: 1 },
    professional: { accounts: 1 },
    brand: { accounts: 1 }
  });

  const handleAccountChange = (planType, accounts) => {
    setSelectedPlans(prev => ({
      ...prev,
      [planType]: { accounts: accounts }
    }));
  };

  const handlePurchase = (planType, planName, pricePerAccount) => {
    const accounts = selectedPlans[planType].accounts;
    const totalPrice = pricePerAccount * accounts;

    // 創建購買數據
    const purchaseData = {
      planType,
      planName,
      pricePerAccount,
      accounts,
      totalPrice
    };

    // 儲存到 localStorage 準備付款
    localStorage.setItem('pendingPurchase', JSON.stringify(purchaseData));

    // 導向註冊/登入頁面
    if (user) {
      navigate('/checkout', { state: purchaseData });
    } else {
      navigate('/register', { state: { returnTo: '/checkout', purchaseData } });
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <Navigation />

      {/* Audiences Section (B2B/B2C) */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'rgba(30, 30, 46, 0.5)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
          }}>
            專為不同角色量身打造
          </h2>

          <p style={{
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 'var(--font-xs)',
            marginBottom: 'clamp(2rem, 4vw, 3rem)',
            maxWidth: '700px',
            margin: '0 auto clamp(2rem, 4vw, 3rem) auto'
          }}>
            無論您是企業 IT 主管、行銷經理還是獨立 blogger，我們的方案皆能滿足您的需求。
          </p>

          <div className="responsive-grid" style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: 'clamp(1.5rem, 4vw, 2rem)',
            marginBottom: 'clamp(2rem, 4vw, 3rem)'
          }}>
            {[
              {
                title: "企業/品牌團隊 (B2B)",
                bullets: [
                  "多品牌治理與標準化流程",
                  "跨平台自動排程與整合",
                  "詳細報表與數據分析，提升 ROI",
                  "長效員工賦能，改善生產力"
                ]
              },
              {
                title: "個人創作者 (B2C)",
                bullets: [
                  "一人操作高產出模式",
                  "一致品牌風格快速套用",
                  "娛樂與便利導向模板",
                  "短期目標實現，快速測試與迭代"
                ]
              }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(135, 206, 235, 0.05)',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  borderRadius: 'clamp(12px, 2vw, 16px)',
                  border: '1px solid rgba(135, 206, 235, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(135, 206, 235, 0.3)';
                  e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.2)';
                }}
              >
                <h3 style={{
                  fontSize: 'var(--font-sm)',
                  fontWeight: '600',
                  color: '#ffffff',
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
                }}>
                  {item.title}
                </h3>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  margin: 0
                }}>
                  {item.bullets.map((bullet, bi) => (
                    <li
                      key={bi}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem',
                        marginBottom: '0.75rem',
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontSize: 'var(--font-xs)'
                      }}
                    >
                      <span style={{
                        color: '#87CEEB',
                        fontSize: 'var(--font-base)',
                        fontWeight: '600',
                        flexShrink: 0
                      }}>✓</span>
                      {bullet}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => navigate('/register')}
              style={{
                background: '#87CEEB',
                border: 'none',
                color: 'white',
                padding: 'clamp(0.75rem, 2vw, 1rem) clamp(2rem, 5vw, 3rem)',
                borderRadius: '12px',
                fontSize: 'var(--font-xs)',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(135, 206, 235, 0.3)',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 24px rgba(135, 206, 235, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 20px rgba(135, 206, 235, 0.3)';
              }}
            >
              選擇適合您的方案
            </button>
          </div>
        </div>
      </section>

      {/* Pricing Plans */}
      <section className="responsive-container" style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)'
      }}>
        <h2 className="responsive-heading" style={{
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: 'clamp(0.5rem, 2vw, 1rem)'
        }}>
          價格方案
        </h2>
        <p className="responsive-text" style={{
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.7)',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          AI 驅動的社群經營服務
        </p>

        <div className="responsive-grid" style={{
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 'clamp(1rem, 3vw, 2rem)',
          marginBottom: 'clamp(2rem, 5vw, 3rem)'
        }}>
          {[
            {
              name: 'AI 基礎版',
              price: '490',
              unit: '/ 帳號 / 月',
              subtitle: '個人或小品牌',
              features: [
                '每日 2 篇自動發文',
                '固定模板 + 固定語氣',
                '基礎圖卡生成',
                '排程發佈功能',
                '基礎數據分析'
              ],
              value: '價值 NT$2,000+ 的內容服務，只需 NT$490/月，ROI 超過 4x。',
              color: '#667eea'
            },
            {
              name: 'AI 專業版',
              price: '790',
              unit: '/ 帳號 / 月',
              subtitle: '中小企業、專業創作者',
              features: [
                '每日 3 篇自動發文',
                '多模板自由切換',
                '自動生成含 CTA 文案',
                '日常經營 + 特殊目的貼文',
                '進階數據分析',
                '多平台同步'
              ],
              value: '價值 NT$5,000+ 的專業工具，只需 NT$790/月，加速成長 3x。',
              popular: true,
              color: '#2563eb'
            },
            {
              name: 'AI 品牌版',
              price: '3990',
              unit: '/ 帳號 / 月',
              subtitle: '需要高度一致性的企業品牌',
              features: [
                '每日 5 篇自動發文',
                '可上傳專屬模板與品牌語氣',
                '自動套用企業 Logo、水印',
                '可設定輸出風格',
                '整合品牌資料庫',
                '專屬推廣內容生成'
              ],
              value: '企業級解決方案，價值 NT$20,000+，只需 NT$3,990/月，確保規模化成功。',
              color: '#5B9BD5'
            }
          ].map((plan, index) => {
            const planType = index === 0 ? 'basic' : index === 1 ? 'professional' : 'brand';
            const accounts = selectedPlans[planType].accounts;
            const totalPrice = parseInt(plan.price) * accounts;

            return (
              <div
                key={index}
                style={{
                  background: plan.popular
                    ? '#1a1a1a'
                    : '#0a0a0a',
                  border: plan.popular ? '2px solid #87CEEB' : '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: 'clamp(16px, 3vw, 20px)',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  position: 'relative',
                  transform: plan.popular ? 'scale(1.05)' : 'scale(1)',
                  boxShadow: plan.popular
                    ? '0 20px 40px rgba(118, 75, 162, 0.2)'
                    : '0 8px 24px rgba(0, 0, 0, 0.1)'
                }}
              >
                {plan.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '-12px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
                    color: 'white',
                    padding: '0.4rem 1.2rem',
                    borderRadius: '20px',
                    fontSize: 'var(--font-xxxs)',
                    fontWeight: '700',
                    boxShadow: '0 4px 12px rgba(118, 75, 162, 0.4)'
                  }}>
                    最受歡迎
                  </div>
                )}

                <h3 style={{
                  fontSize: 'var(--font-base)',
                  marginBottom: '0.5rem',
                  fontWeight: '700',
                  color: '#ffffff'
                }}>
                  {plan.name}
                </h3>

                <div className="responsive-text" style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                  fontWeight: '500'
                }}>
                  適合：{plan.subtitle}
                </div>

                <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
                  <div style={{ marginBottom: '0.5rem' }}>
                    <span style={{
                      fontSize: 'var(--font-4xl)',
                      fontWeight: '800',
                      color: '#ffffff',
                      lineHeight: '1'
                    }}>
                      NT${plan.price}
                    </span>
                  </div>
                  <span style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: 'var(--font-xs)', fontWeight: '500' }}>{plan.unit}</span>
                </div>

                {/* 帳號數量選擇器 */}
                <div style={{ marginBottom: '1.5rem' }}>
                  <div style={{
                    fontSize: 'var(--font-xxs)',
                    color: '#ffffff',
                    marginBottom: '0.5rem',
                    fontWeight: '600'
                  }}>
                    選擇帳號數量：
                  </div>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '1rem'
                  }}>
                    <button
                      onClick={() => handleAccountChange(planType, Math.max(1, accounts - 1))}
                      style={{
                        background: '#3a3a3a',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        color: '#ffffff',
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '600',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      −
                    </button>
                    <span style={{
                      color: '#ffffff',
                      fontSize: 'var(--font-sm)',
                      fontWeight: '700',
                      minWidth: '40px',
                      textAlign: 'center'
                    }}>
                      {accounts}
                    </span>
                    <button
                      onClick={() => handleAccountChange(planType, accounts + 1)}
                      disabled={planType === 'basic' && accounts >= 3}
                      style={{
                        background: (planType === 'basic' && accounts >= 3) ? '#2a2a2a' : '#3a3a3a',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        color: (planType === 'basic' && accounts >= 3) ? 'rgba(255, 255, 255, 0.5)' : '#ffffff',
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        cursor: (planType === 'basic' && accounts >= 3) ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: '600',
                        boxShadow: (planType === 'basic' && accounts >= 3) ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      +
                    </button>
                    <span style={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      fontSize: 'var(--font-xxs)',
                      marginLeft: '0.5rem',
                      fontWeight: '500'
                    }}>
                      個帳號
                    </span>
                  </div>

                  {/* 平台限制說明 */}
                  {planType === 'basic' && (
                    <div style={{
                      fontSize: 'var(--font-xxxs)',
                      color: 'rgba(255, 255, 255, 0.5)',
                      marginBottom: '0.5rem',
                      fontWeight: '500'
                    }}>
                      ✨ 支援平台：Instagram、Facebook、Threads（最多3個帳號）
                    </div>
                  )}

                  {/* 總價顯示 */}
                  <div style={{
                    background: '#1a1a1a',
                    padding: '0.75rem',
                    borderRadius: '12px',
                    textAlign: 'center',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)'
                  }}>
                    <div style={{
                      fontSize: 'var(--font-xxxs)',
                      color: 'rgba(255, 255, 255, 0.6)',
                      marginBottom: '0.25rem',
                      fontWeight: '600'
                    }}>
                      月費總計
                    </div>
                    <div style={{
                      fontSize: 'var(--font-xl)',
                      fontWeight: '800',
                      color: '#ffffff'
                    }}>
                      NT${totalPrice.toLocaleString()}
                    </div>
                  </div>
                </div>

                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '2rem' }}>
                  {plan.features.map((feature, fi) => (
                    <li key={fi} style={{
                      padding: '0.5rem 0',
                      borderBottom: fi === plan.features.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.05)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}>
                      <span style={{ color: plan.color, fontSize: 'var(--font-xs)', fontWeight: '600' }}>✓</span>
                      <span style={{ color: '#ffffff', fontSize: 'var(--font-xxs)', fontWeight: '500' }}>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Value Comparison */}
                <p style={{
                  fontSize: 'var(--font-xxs)',
                  color: '#87CEEB',
                  marginBottom: '1.5rem',
                  textAlign: 'center',
                  fontWeight: '500',
                  lineHeight: '1.5'
                }}>
                  {plan.value}
                </p>

                <button
                  onClick={() => handlePurchase(planType, plan.name, parseInt(plan.price))}
                  style={{
                    width: '100%',
                    background: plan.popular ? 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)' : '#333333',
                    border: 'none',
                    color: 'white',
                    padding: '1rem',
                    borderRadius: '12px',
                    fontSize: 'var(--font-xs)',
                    fontWeight: '700',
                    cursor: 'pointer',
                    boxShadow: plan.popular ? '0 8px 20px rgba(135, 206, 235, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.15)',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = plan.popular ? '0 12px 24px rgba(135, 206, 235, 0.4)' : '0 8px 16px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = plan.popular ? '0 8px 20px rgba(135, 206, 235, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                >
                  立即購買 ({accounts} 個帳號)
                </button>
              </div>
            );
          })}
        </div>

        {/* 矩陣方案 - 特別設計 */}
        <div
          style={{
            background: "#000000",
            border: '2px solid rgba(135, 206, 235, 0.4)',
            borderRadius: '24px',
            padding: '2.5rem',
            position: 'relative',
            overflow: 'hidden',
            marginTop: 'calc(2rem + 200px)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 0 20px rgba(135, 206, 235, 0.3), 0 8px 24px rgba(135, 206, 235, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 0 30px rgba(135, 206, 235, 0.5), 0 20px 40px rgba(135, 206, 235, 0.3)';
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 0 20px rgba(135, 206, 235, 0.3), 0 8px 24px rgba(135, 206, 235, 0.2)';
            e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.4)';
          }}
        >
          {/* 特殊標籤 */}
          <div style={{
            position: 'absolute',
            top: '-1px',
            right: '2rem',
            background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
            color: '#ffffff',
            padding: '0.5rem 1.5rem',
            borderRadius: '0 0 12px 12px',
            fontSize: 'var(--font-xxxs)',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <Icon icon="mdi:rocket-launch" style={{ fontSize: 'var(--font-xs)' }} />
            矩阵行销
          </div>

          {/* 頭部區域 - 標題 */}
          <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 5vw, 3rem)', marginTop: 'clamp(1.5rem, 4vw, 2rem)' }}>
            <h3 style={{
              fontSize: 'var(--font-xl)',
              fontWeight: '700',
              color: '#ffffff',
              margin: 0,
              marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
            }}>
              AI 矩陣方案・小型版
            </h3>

            <div style={{
              fontSize: 'var(--font-xs)',
              color: 'rgba(255, 255, 255, 0.8)',
              marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
              fontWeight: '500',
              maxWidth: '600px',
              margin: '0 auto clamp(1.5rem, 4vw, 2rem)'
            }}>
              適合：需要快速建立「多帳號行銷矩陣」的企業
            </div>
          </div>

          {/* 功能特色區域 */}
          <div style={{ marginBottom: 'clamp(2rem, 5vw, 3rem)' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: 'clamp(1rem, 3vw, 1.5rem)',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {[
                '每日 5 篇專業發文（每帳號）',
                '專業行銷人員 15 分鐘需求訪談',
                '量身規劃完整矩陣貼文策略',
                '每個帳號具有人物設定（persona）',
                '多角度觸及市場',
                '形成小型內容矩陣，強化演算法效應'
              ].map((feature, fi) => (
                <div key={fi} style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  padding: 'clamp(0.75rem, 2vw, 1rem)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  backdropFilter: 'blur(5px)'
                }}>
                  <span style={{
                    color: '#ffffff',
                    fontSize: 'var(--font-base)',
                    background: '#87CEEB',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>✓</span>
                  <span style={{
                    color: '#ffffff',
                    fontWeight: '500',
                    fontSize: 'var(--font-xs)',
                    lineHeight: '1.4'
                  }}>
                    {feature}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* 按鈕區域 */}
          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => window.location.href = 'mailto:official@viralarc-ai.com?subject=矩陣方案諮詢'}
              style={{
                background: '#87CEEB',
                border: 'none',
                color: 'white',
                padding: 'clamp(1.2rem, 3.5vw, 1.5rem) clamp(2.5rem, 6vw, 3.5rem)',
                borderRadius: '16px',
                fontSize: 'var(--font-base)',
                fontWeight: '700',
                cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(135, 206, 235, 0.3)',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 32px rgba(135, 206, 235, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 24px rgba(135, 206, 235, 0.3)';
              }}
            >
              立即諮詢
            </button>
            <div style={{
              fontSize: 'var(--font-xxs)',
              color: 'white',
              marginTop: '0.75rem',
              fontWeight: '500'
            }}>
              需求評估 + 策略規劃
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PricingPage;
